import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  wrap: {
    whiteSpace: 'nowrap' as const,
  },
  icon: {
    fontWeight: 'normal' as const,
    fontSize: '16px',
    marginRight: 2,
  },
  active: {
    color: '#00b050',
  },
  inactive: {
    color: '#c0c0c0',
  },
}));
